import { ClientType } from '../../model/client/clientType';

export const CLIENT_TYPE_TRANSLATIONS: Record<ClientType, string> = {
  [ClientType.Employer]: 'Наниматель',
  [ClientType.Specialist]: 'Специалист',
};
